import { Chain, anvil as vanillaAnvil } from "viem/chains";
import paymasters from "contracts/paymaster.json";
import { Hex } from "viem";

export const anvil = {
  ...vanillaAnvil,
  rpcUrls: {
    ...vanillaAnvil.rpcUrls,
    quarryPassIssuer: {
      http: ["http://127.0.0.1:3003/rpc"],
    },
  },
  contracts: {
    quarryPaymaster: {
      address: paymasters[31337].address as Hex,
      blockCreated: 0,
    },
  },
  blockExplorers: {
    default: {
      name: "MUD Worlds Explorer",
      url: "http://localhost:13690/anvil/worlds",
    },
    worldsExplorer: {
      name: "MUD Worlds Explorer",
      url: "http://localhost:13690/anvil/worlds",
    },
  },
} as const satisfies Chain;
